import { render, staticRenderFns } from "./Type5.vue?vue&type=template&id=b41d7422&scoped=true"
import script from "./Type5.vue?vue&type=script&lang=js"
export * from "./Type5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41d7422",
  null
  
)

export default component.exports